import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'

export default function SidebarClubEmpty({client, handleClientSelect, handleClubSelect, isCollapsed }) {
	const { t } = useTranslation()
	const location = useLocation()
	const {logout} = useAuth()

	const isActive = (path) => {
		return location.pathname.includes(path)
	}

  	return (
		<div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} id="sidebar">
			<Link to="/">
				<img 
					src={isCollapsed ? '/images/logotipo-reducido-movil.svg' : '/images/logotipo-sdplay-cabecera.svg'} 
					id="logo-menu" 
					alt='Logotipo SDPlay' 
				/>
			</Link>
			<Nav className="flex-column p-0">
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.lobby")}`}
						className={isActive(t("url.club.lobby")) ? 'active' : ''}
					>
						<img src="/images/menus/dashboard.svg" alt={t('menus.general.dashboard')}/> 
						{!isCollapsed && t('menus.general.mydashboard')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.accountdata")}`}
						className={isActive(t("url.club.accountdata")) ? 'active' : ''}
					>
						<img src="/images/menus/config.svg" alt={t('menus.general.config')}/> 
						{!isCollapsed && t('menus.general.accountdata')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link to={'/'} onClick={() => handleClubSelect(null)}>
						<img src="/images/cart.svg" alt={t('menus.general.marketplace')}/> 
						{!isCollapsed && t('menus.general.marketplace')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link to="/" onClick={logout}>
						<img src='/images/logout.svg' alt={t('menus.logout')} />
						{!isCollapsed && t('menus.logout')}
					</Link>
				</Nav.Item>
			</Nav>
		</div>
	)
}